import { Link } from 'react-router-dom';
import type { Media } from '@/types';
import { mediaPath } from '@/lib/catalog';

interface MediaCardProps {
  item: Media;
  className?: string;
}

export default function MediaCard({ item, className = '' }: MediaCardProps) {
  return (
    <Link
      to={mediaPath(item)}
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:border-primary-300 ${className}`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} ${item.genres.join(' ')} ${item.kind === 'movie' ? '电影' : '电视剧'}`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 transition group-hover:opacity-100" />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-bold text-secondary-950">
          <i className="ri-star-fill text-[10px]" />
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {item.kind === 'movie' ? '电影' : '剧集'}
        </span>
        <span className="pointer-events-none absolute bottom-2 left-1/2 flex h-9 w-9 -translate-x-1/2 translate-y-2 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 transition duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <i className="ri-play-mini-fill text-2xl" />
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-bold text-foreground-950 transition group-hover:text-primary-600 md:text-[15px]">
          {item.title}
        </h3>
        <p className="line-clamp-1 text-xs text-foreground-500">{item.genres.join(' · ')}</p>
        <div className="mt-auto flex items-center justify-between pt-1 text-xs text-foreground-500">
          <span>{item.region}</span>
          <span>{item.year}</span>
        </div>
      </div>
    </Link>
  );
}